"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimitiveSchema = exports.Schema = void 0;
const aspect_1 = require("./aspect");
class Schema extends aspect_1.Aspect {
    constructor(schemaName, description, type, initializer) {
        super(schemaName, description);
        this.type = type;
        this.apply({
            language: {
                default: {},
            },
            protocol: {},
        }, initializer);
    }
}
exports.Schema = Schema;
class PrimitiveSchema extends Schema {
    constructor(name, description, schemaType, objectInitializer) {
        super(name.indexOf("·") > -1 ? schemaType : name, description, schemaType);
        this.apply(objectInitializer);
    }
}
exports.PrimitiveSchema = PrimitiveSchema;
//# sourceMappingURL=schema.js.map